<template>
  <section id="basicInformation" class="hotelSection beige">
    <div class="hotelSectionInner">
      <h2 class="hotelH2">基本情報</h2>
      <a
        v-if="basicInfo.hotelWebsite"
        class="hotelBtnH2"
        :href="basicInfo.hotelWebsite"
        target="_blank"
        >公式ウェブサイト
        <tk-icon name="open_link" class="icoOpenLink"></tk-icon>
      </a>

      <div class="hotelBasicBox">
        <div class="hotelBasicBoxInner column2">
          <dl class="hotelBasicBoxItem">
            <dt>チェックイン</dt>
            <dd>{{ basicInfo.checkinTime }}~</dd>
          </dl>
          <dl class="hotelBasicBoxItem">
            <dt>チェックアウト</dt>
            <dd>{{ basicInfo.checkoutTime }}</dd>
          </dl>
          <dl class="hotelBasicBoxItem">
            <dt>電話番号</dt>
            <dd>{{ basicInfo.phoneNumber }}</dd>
          </dl>
          <dl v-if="basicInfo.fax" class="hotelBasicBoxItem">
            <dt>FAX番号</dt>
            <dd>{{ basicInfo.fax }}</dd>
          </dl>
        </div>
        <div class="hotelBasicBoxInner">
          <dl class="hotelBasicBoxItem">
            <dt>所在地</dt>
            <dd>{{ basicInfo.localtion }}</dd>
          </dl>
        </div>
      </div>

      <div class="hotelBasicBox">
        <div class="hotelBasicBoxInner columnIcon">
          <dl
            v-if="Object.keys(publicPath).length > 0"
            class="hotelBasicBoxItem"
          >
            <dt>
              <tk-icon name="ofuro" class="icoOfuro"></tk-icon>
              共同浴場
            </dt>
            <dd>
              <div>{{ publicPath.description }}</div>
              <ul class="hotelBasicBoxImage">
                <li v-for="image in publicPath.images" :key="image">
                  <img alt="共同浴場の写真" :src="image" />
                </li>
              </ul>
            </dd>
          </dl>
          <dl
            v-if="Object.keys(restaurant).length > 0"
            class="hotelBasicBoxItem"
          >
            <dt>
              <tk-icon name="meal" class="icoRestaurant"></tk-icon>
              お食事処
            </dt>
            <dd>
              <div>
                {{ restaurant.description }}
              </div>
              <ul class="hotelBasicBoxImage">
                <li v-for="image in restaurant.images" :key="image">
                  <img alt="お食事処の写真" :src="image" />
                </li>
              </ul>
            </dd>
          </dl>
        </div>

        <div class="hotelBasicBoxInner">
          <dl class="hotelBasicBoxItem hotel-amenity">
            <dt>施設・サービス</dt>
            <dd>
              <div class="hotelBasicBoxTable">
                <ul
                  v-for="(facilities, index) in displayFacilities"
                  :key="index"
                >
                  <li
                    v-for="(facility, fid) in facilities"
                    :key="`facility-${fid}`"
                    :class="facility.cssClass"
                  >
                    {{ facility.name }}
                  </li>
                </ul>
              </div>
            </dd>
          </dl>
        </div>
      </div>

      <div v-if="basicInfo.notes" class="hotelBasicBox">
        <dl class="hotelBasicBoxItem">
          <dt>備考・注意事項</dt>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <dd v-html="basicInfo.notes"></dd>
        </dl>
      </div>
    </div>
  </section>
</template>

<script>
import TkIcon from '../../atoms/TkIcon/TkIcon'
import { getSupportFacilitiesByService } from './facilities-and-services'

export default {
  name: 'TkHotelInformation',
  components: { TkIcon },
  props: {
    basicInfo: {
      type: Object,
      required: true,
    },
    publicPath: {
      type: Object,
      default: () => {},
    },
    restaurant: {
      type: Object,
      default: () => {},
    },
    facilitiesAndServices: {
      type: Array,
      default: () => [],
    },
    service: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayFacilities() {
      const allFacility = getSupportFacilitiesByService(this.service).map(
        ({ mappingIds, name }) => {
          const available = this.facilitiesAndServices.some((i) =>
            mappingIds.includes(i)
          )
          return {
            name,
            cssClass: available ? 'true' : 'false',
          }
        }
      )
      const splitIndex = Math.ceil(allFacility.length / 2)
      return [
        allFacility.slice(0, splitIndex),
        allFacility.slice(splitIndex, allFacility.length),
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@ota-frontend/ui/src/scss/components/TkHotelInformation.scss';
</style>
